let PackagingTypeDto = {
  id: -1,
  packagingType: null
}

export default PackagingTypeDto
